<template>
<footer>
  <p>Copyright © {{ yearS }} - {{yearE}} <a href="/"> Mohammad Ali</a>. All Rights Reserved.</p>
</footer>
</template>

<script>
export default {
  name: "VueFooter",
  data() {
    return {
      yearS: 2020,
      yearE: 2020,
    };
  },
  mounted() {
    this.yearE = new Date().getFullYear();
  }

}
</script>

<style scoped>
footer{
  padding: 50px 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-align: center;
  align-content:center;
  background-color: rgba(0,0,0,0.1);
}
footer p{
  padding: 0;
  margin: 0;
}
footer a{
  color: #fff;
  transition: all 0.3s linear 0.01s;
}
footer a:hover,
footer a:focus,
footer a:active{
  color: var(--primary-color);
  transition: all 0.3s linear 0.01s;
}
</style>